<div class="mb-2"*ngIf="outcomeSec && !title.includes('XBRL') && !title.includes('GAAP Taxonomy Elements')">
  <div hidden class="ptb-archive" *ngIf="PendingContentPage">
    <div class="flex-display">
      <div class="cursor-pointer">
        <img src="../../../../assets/icons/Pending.svg" class="pending-image" alt="alarm">
      </div>
      <div class="PendingContent-general-header">
        {{sectionHeader}}
      </div>
      <div class="text-align-right singleLine">
        <div class="cursor-pointer ">
          <span (click)="EditPCS()">
            <a class="anchor-black">Edit</a>
            <img src="../../../../assets/icons/pencil.svg" class="pencil-iconwidth ml-1px underline" alt="alarm">
          </span>
          <span class="ml-2" (click)="ResetPCS()"> <a class="anchor-black">Reset</a></span>
        </div>
      </div>
    </div>
    <div class="ml-2 flex-display">
      <div class="archive-btn">
        <span class="archive-Info mr-14px">{{showingContent_Label}} {{FiscalDate}}</span>
        <span class="archive-Info mr-14px">{{fillingStatus_Label}}:{{fillingStatus}}</span>
        <span class="archive-Info mr-14px">{{periodTypeLabel}}: {{PeriodType}}</span>

      </div>
    </div>
  </div>
  <div class="padding-sec-content-screen" [ngClass]="PendingContentPage? '': 'mt-3rem'">
    <div *ngIf="!hasActualContent">
      <div class="componentHeader pt-1">
        <div><app-breadcrumbs-path [crumbData]="crumbData"></app-breadcrumbs-path></div>
        <div class="flex-display print-all-content" tabindex="0">
          <div class="float-L history-heading flex-display">
            <div>
              <h1 id="pageHeadingSec" role="heading" class="generalHeader" [innerHTML]="pageHeadingSec">
              </h1>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="flex-display mb-3 ml-72 " *ngIf="PendingContentPage">
      <div hidden>
        <img src="../../../../assets/icons/Archive.svg" class="whatsNew-image image-info" alt="Archive">
      </div>
      <div hidden class="h-20px highlight-blue border-bottom-help cursor-pointer" (click)="OpenPCS()">
        PCS
      </div>
    </div>

    <div class="print-all-content">
      <div class="componentHeader mb-2">
        <div class="info-box bold itcHeavyFont font-32 paddingtbl-0-6 info-box-width mt_1">
          <label>Securities and Exchange Commission (SEC)</label>
        </div>
      </div>
    </div>

    <div *ngIf="paragraphTitleContentSec.length == 0">
      <div *ngFor="let info of topicBodyContentSec">
        <div class="componentHeader mb-2 print-all-content" *ngIf="index == info.pageInfoPosition">
          <div class="flex-display info-box info-box-width mb-24px mt-40px">
            <div class="ml-12"><img src="../../../assets/icons/Info..svg" class="info-img" alt="topic info"></div>
            <label class="ml-8 para-content content-blue">
              <span> <span class="bold" [innerHTML]="info.contentPageTitle"></span><span *ngIf="info.contentPageTitle!='' || info.contentPageTitle!=null">:</span><span class="generalNote" (click)="openLinkById($event)" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" [innerHTML]="info.contentPageBody|safeContentHTML"></span></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div *ngFor="let para of paragraphTitleContentSec; let index = index">
      <div *ngFor="let info of topicBodyContentSec">
        <div class="componentHeader mb-2 print-all-content" *ngIf="index == info.pageInfoPosition">
          <div class="flex-display info-box info-box-width mb-24px mt-40px">
            <div class="ml-12"><img src="../../../assets/icons/Info..svg" class="info-img" alt="topic info"></div>
            <label class="ml-8 para-content content-blue">
              <span> <span class="bold" [innerHTML]="info.contentPageTitle"></span><span *ngIf="info.contentPageTitle!='' || info.contentPageTitle!=null">:</span><span class="generalNote" (click)="openLinkById($event)" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" [innerHTML]="info.contentPageBody|safeContentHTML"></span></span>
            </label>
          </div>
        </div>
      </div>
      <div class="componentHeader flex-display topicBody print-all-content" *ngIf="para.headingName.topicTitleName != ''">
        <div class="width-75" tabindex="0" [id]="para.headingName.topicTitleId">
          <h2 class="paraHeader">
            <span [innerHTML]="para.headingName.topicTitleName"></span>
          </h2>
        </div>
      </div>
      <div class="componentHeader" *ngFor="let paragraph of para.paragraphContent">
        <div class="componentHeaderPrint print-all-content">
          <div *ngIf="paragraph.paragroup != ''" class="width-90">
            <div class="mt_1 mb-1">
              <h3 class="annotation-content-title  topicBody" tabindex="0">
                <span>>&nbsp;</span><span [innerHTML]="paragraph.paragroup"></span>
              </h3>
            </div>
          </div>
        </div>
      <pub-dita-content [id]="paragraph.id" [dita]="paragraph.paraContent" [s3ImageBasePath]="s3ImageBasePath" [paraTitle]="paragraph.paraTitle" [annotationCount]="annotationCount[paragraph.id]" [bookmarkCount]="bookmarkCount[paragraph.id]" printqueueAdd="false" [actionLabel]="menuListItems" [archivePage]="archivePage" [paraNum]="paragraph.paraNum" [pageNums]="pageNumsForCount" [PendingContentMerge]="PendingContentMergeList" [UserInfo]="UserInfo" [crossreferencestandardType]="crossreferencestandardType" [crossreferencestandardNumber]="crossreferencestandardNumber" [crossreferenceparagraphNumber]="crossreferenceparagraphNumber" [crossReferencedContentID]="crossReferencedContentID" [BreadcrumbPath]="breadcrumbPath" [topic_subtopicNum]="topic_subtopicNum" [pageurl]="pageurl"></pub-dita-content>
      </div>
    </div>
    <div class="pb-5"></div>
  </div>
</div>
